import {breakpoint} from "../layout/common";

export let SecretlyNumbered = ({number, children}) => {
    return <>
        <span className={`d-inline d-${breakpoint}-none`}>{number}.&nbsp;</span>
        {children}
    </>
}